import React from 'react';
import { DisplayMode } from '../../RenderForm';
import { ShortTextFieldWrapper, ViewWrapper } from '../common/questionWrappers';
export var ViewShortText = function ViewShortText(_ref) {
  var value = _ref.value,
    displayMode = _ref.displayMode;
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    return /*#__PURE__*/React.createElement(ShortTextFieldWrapper, {
      isDisabled: true
    }, /*#__PURE__*/React.createElement("div", null, value));
  }
  return /*#__PURE__*/React.createElement(ViewWrapper, null, value);
};